// src/components/Services.js
import React from 'react';
import { Container, Typography } from '@mui/material';
import { footerConfigs } from "../components/footerConfigs";
const Services = () => {
  const school = footerConfigs.bheema;
  return (
    <Container>
      <Typography variant="h4" sx={{ mt: 4 }}>Our Courses</Typography>
      <Typography sx={{ mt: 2 }}>
     At {school.brandName || "School Name"} , we offer specialized courses,summer vacation with regular classes
      </Typography>
    </Container>
  );
};

export default Services;
